/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Fact_LicenseInputs */

const en_wc_fact_license = /** @type {(inputs: Wc_Fact_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT / Apache-2.0`)
};

/**
* | output |
* | --- |
* | "MIT / Apache-2.0" |
*
* @param {Wc_Fact_LicenseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_fact_license = /** @type {((inputs?: Wc_Fact_LicenseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Fact_LicenseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_fact_license(inputs)
});
export { wc_fact_license as "wc.fact.license" }